module.exports = __webpack_public_path__ + "components/rewards/snowtrex/static/logo-06c5c3c651d3a625695ee7b60a49d054.png";